import React from 'react';
import colors from 'src/style/colors';
import { ArrowPurple } from '../Icons/arrows';
import { useHover } from '../../utils/useHover';
import { mediaQueries } from 'src/style/breakpoints';
import { Paragraph, Sentence } from '../Typography/index';
import { Link } from 'gatsby';
import { useMediaQueries } from '../../utils/MediaQueries';

const SessionItem = ({
  date,
  priceIndividuals,
  priceCorporate,
  priceRemote,
  fromFormationsPageType,
  sessionId,
  isFull,
  withFormat,
  isFullRemote,
}) => {
  const [hoverRef, isHover] = useHover();
  const mqs = useMediaQueries();
  //
  const showPrices = () => {
    const prices = [];
    if (fromFormationsPageType !== 'Alternance' && (priceRemote || priceIndividuals)) {
      prices.push(
        <div
          css={{
            borderRight: `1px solid ${!isFull ? colors.purple : colors.midGrey}`,
            marginRight: 20,
            paddingRight: 20,
            [mediaQueries.phoneOnly]: {
              marginRight: 16,
              paddingRight: 16,
            },
          }}
        >
          <Sentence
            css={{
              textTransform: 'uppercase',
              color: !isFull ? colors.purple : colors.midGrey,
              fontSize: 10,
              marginTop: -4,
              letterSpacing: 0.5,
              [mediaQueries.phoneOnly]: {
                fontSize: 9.5,
              },
            }}
            noSpacing={true}
          >
            {fromFormationsPageType === 'E-Learning' ? (
              <>
                financement personnel<br></br>FRANCE TRAVAIL / CPF
              </>
            ) : (
              'financement personnel / CPF'
            )}
          </Sentence>
          <div
            css={{
              display: 'flex',
              /* flexDirection: 'row',
          [mediaQueries.phoneOnly]: {
            flexDirection: 'column',
          }, */
              flexDirection: 'column',
            }}
          >
            <Sentence
              css={{
                color: !isFull ? colors.purple : colors.midGrey,
                lineHeight: '15px',
                [mediaQueries.tabletPortraitUp]: {
                  marginRight: 0,
                  marginBottom: 5,
                },
                [mediaQueries.phoneOnly]: {
                  fontSize: 16,
                  marginBottom: 5,
                  lineHeight: '16px',
                },
              }}
              noSpacing={true}
            >
              <span
                css={{
                  fontWeight: 'bold',
                }}
              >
                {priceRemote}{' '}
              </span>
              <span
                css={{
                  fontSize: 14,
                }}
              >
                à&nbsp;distance
              </span>
            </Sentence>
            {fromFormationsPageType === 'Temps Plein' && (
              <Sentence
                css={{
                  color: !isFull ? colors.purple : colors.midGrey,
                  lineHeight: '15px',
                  [mediaQueries.phoneOnly]: {
                    fontSize: 16,
                    lineHeight: '16px',
                  },
                }}
                noSpacing={true}
              >
                <span css={{ fontWeight: 'bold' }}>{priceIndividuals} </span>
                <span css={{ fontSize: 14 }}>en&nbsp;présentiel</span>
              </Sentence>
            )}
          </div>
        </div>
      );
    }
    switch (fromFormationsPageType) {
      case 'Temps Plein':
      case 'Temps Partiel':
      case 'E-Learning':
        if (priceCorporate) {
          prices.push(
            <div
              css={{
                marginBottom: -1,
              }}
            >
              <Sentence
                css={{
                  textTransform: 'uppercase',
                  color: !isFull ? colors.purple : colors.midGrey,
                  fontSize: 10,
                  marginTop: -4,
                  letterSpacing: 0.5,
                  [mediaQueries.phoneOnly]: {
                    fontSize: 9.5,
                  },
                }}
                noSpacing={true}
              >
                Entreprise / OPCO {mqs.phoneOnly ? <br></br> : '/ '}Transitions Pro
              </Sentence>
              <Sentence
                css={{
                  color: !isFull ? colors.purple : colors.midGrey,
                  lineHeight: '15px',
                  fontWeight: 'bold',
                  [mediaQueries.phoneOnly]: {
                    fontSize: 16,
                  },
                }}
                noSpacing={true}
              >
                {priceCorporate}{' '}
                <span css={{ fontSize: 14, fontWeight: 500 }}>HT (TVA non&nbsp;applicable)</span>
              </Sentence>

              {fromFormationsPageType !== 'E-Learning' ? (
                <>
                  <Sentence
                    css={{
                      textTransform: 'uppercase',
                      color: !isFull ? colors.purple : colors.midGrey,
                      fontSize: 10,
                      marginTop: 4,
                      letterSpacing: 0.5,
                      [mediaQueries.phoneOnly]: {
                        fontSize: 9.5,
                      },
                    }}
                    noSpacing={true}
                  >
                    CSP - Contrat de Sécurisation Professionnelle
                  </Sentence>
                  <Sentence
                    css={{
                      color: !isFull ? colors.purple : colors.midGrey,
                      lineHeight: '15px',
                      [mediaQueries.tabletPortraitUp]: {
                        marginRight: 0,
                        marginBottom: 5,
                      },
                      [mediaQueries.phoneOnly]: {
                        fontSize: 16,
                        marginBottom: 5,
                      },
                    }}
                    noSpacing={true}
                  >
                    <span css={{ fontWeight: 'bold' }}>8.000€ </span>
                    <span css={{ fontSize: 14 }}>à&nbsp;distance</span>
                  </Sentence>
                  {fromFormationsPageType === 'Temps Plein' ? (
                    <Sentence
                      css={{
                        color: !isFull ? colors.purple : colors.midGrey,
                        lineHeight: '15px',
                        [mediaQueries.phoneOnly]: {
                          fontSize: 16,
                          lineHeight: '16px',
                        },
                      }}
                      noSpacing={true}
                    >
                      <span css={{ fontWeight: 'bold' }}>9.000€ </span>
                      <span css={{ fontSize: 14 }}>en&nbsp;présentiel</span>
                    </Sentence>
                  ) : null}
                </>
              ) : null}
            </div>
          );
        }
        break;
      case 'Alternance':
        prices.push(
          <div>
            <Sentence
              css={{
                textTransform: 'uppercase',
                color: !isFull ? colors.purple : colors.midGrey,
                fontSize: 10,
                marginTop: -4,
                letterSpacing: 0.5,
                [mediaQueries.phoneOnly]: {
                  fontSize: 9.5,
                },
              }}
            >
              Prise en charge par l'entreprise (OPCO)
            </Sentence>
            <Sentence
              css={{
                color: !isFull ? colors.purple : colors.midGrey,
                lineHeight: '15px',
                fontWeight: 'bold',
                [mediaQueries.phoneOnly]: {
                  fontSize: 16,
                },
              }}
            >
              {/* 12.500€ <span css={{ fontSize: 11 }}>HT (TVA non applicable)</span> */}
              <span css={{ fontSize: 15 }}>Salaire mensuel (+ de 26 ans) : </span>1.747 euros brut
            </Sentence>
          </div>
        );
        break;
    }
    return prices;
  };
  //
  return (
    <Link
      data-cy="next-sessions-apply"
      to={'/postuler'}
      state={{
        fromFormationsPage: {
          type: fromFormationsPageType,
          certification: fromFormationsPageType === 'E-Learning' ? 'RNCP5' : 'RNCP6',
          id: sessionId,
          date: date,
          withFormat: withFormat,
        },
      }}
      ref={hoverRef}
      css={{
        textDecoration: 'none',
        width: '80%',
        maxWidth: 560,
        minWidth: 40,
        position: 'relative',
        backgroundColor: colors.lightGrey,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 32,
        marginBottom: 8,
        cursor: !isFull && 'pointer',
        pointerEvents: isFull && 'none',
        boxShadow:
          isHover && !isFull ? '0 10px 15px rgba(0,0,0,.09)' : '0 5px 15px rgba(0,0,0,.07)',
        transitionProperty: 'all',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'cubic-bezier(0.41, 0.094, 0.54, 0.07)',
        transitionDelay: '0s',
        overflow: 'hidden',
        boxSizing: 'content-box',
        ...(isHover && !isFull ? { paddingLeft: 50 } : {}),
        [mediaQueries.tabletPortraitUp]: {
          width: '88%',
        },
        [mediaQueries.tabletLandscapeUp]: {
          minWidth: 534,
        },
        [mediaQueries.phoneOnly]: {
          padding: 20,
          marginLeft: 0,
          width: '100%',
          boxSizing: 'border-box',
        },
      }}
    >
      <div
        css={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: 10,
          borderRadius: '10px 0px 0px 10px',
          transform: isHover && !isFull ? 'translateX(0px)' : 'translateX(-16px)',
          background: colors.yellow,
          transitionProperty: 'all',
          transitionDuration: '0.2s',
          transitionTimingFunction: 'cubic-bezier(0.41, 0.094, 0.54, 0.07)',
        }}
      />
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <div
          css={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            [mediaQueries.phoneOnly]: {
              flexDirection: 'column-reverse',
              alignItems: 'flex-start',
            },
            [mediaQueries.tabletLandscapeUp]: {
              width: '400px',
            },
          }}
        >
          <Sentence
            css={{
              textTransform: 'uppercase',
              color: !isFull ? colors.purpleDark : colors.midGrey,
              fontSize: 10,
              padding: 0,
              paddingBottom: 8,
              letterSpacing: 0.8,
              lineHeight: '10px',
              [mediaQueries.phoneOnly]: {
                fontSize: 9.5,
                lineHeight: '10px',
                paddingBottom: 6,
              },
            }}
          >
            {fromFormationsPageType === 'E-Learning'
              ? 'Développeur Web - E-learning + mentoring'
              : `Développeur Web et Mobile - ${fromFormationsPageType}`}{' '}
            {fromFormationsPageType === 'Temps Plein' && '- Paris'}
          </Sentence>
        </div>

        <Sentence
          css={{
            fontSize: 23,
            padding: 0,
            fontWeight: 'bold',
            color: !isFull ? colors.purpleDark : colors.midGrey,
          }}
        >
          {date}
        </Sentence>
        <div
          css={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: fromFormationsPageType === 'E-Learning' ? 'end' : '',
            paddingTop: 24,
            [mediaQueries.phoneOnly]: {
              paddingTop: 16,
            },
            alignSelf: isFull && mqs.phoneOnly ? 'center' : 'initial',
          }}
        >
          {mqs.phoneOnly && isFull ? (
            <Paragraph
              css={{
                fontWeight: 'bold',
                fontSize: 12,
                color: colors.purple,
                display: 'flex',
                padding: 0,
                alignItems: 'center',
                textTransform: 'uppercase',
              }}
            >
              Complet
            </Paragraph>
          ) : (
            <>{showPrices()}</>
          )}
        </div>
      </div>
      <div css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {!isFull ? (
          <Paragraph
            css={{
              padding: 0,
              paddingRight: 12,
              position: 'relative',
              color: colors.purple,
              fontSize: 16,
              fontWeight: 'bold',
              transition: 'opacity 0.2s cubic-bezier(0.41, 0.094, 0.54, 0.07)',
              opacity: isHover ? 1 : 0,
              [mediaQueries.phoneOnly]: {
                display: 'none',
              },
            }}
          >
            Postuler
          </Paragraph>
        ) : (
          <Paragraph
            css={{
              fontWeight: 'bold',
              color: colors.purple,
              textTransform: 'uppercase',
              letterSpacing: 1,
              fontSize: 16,
              [mediaQueries.phoneOnly]: {
                display: 'none',
              },
            }}
          >
            Complet
          </Paragraph>
        )}

        {!isFull && <ArrowPurple />}
      </div>
    </Link>
  );
};
export default SessionItem;
